import React, { useState, useEffect, useContext } from "react";
import { useForm } from 'react-hook-form';
import './TicketForm.css'; // Import this CSS file
import { AppContext } from "../../../Context/Context";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";

const CreateTicketForm = () => {
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const onSubmit = (data) => {
    console.log('Submitted Ticket:', data);
  };

  return (
    <div className={`over_all_container search_prnt ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      <Helmet>
        <meta charSet="utf-8" />
        <title> Support Ticket </title>
      </Helmet>
      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  Support Ticket
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Support Ticket', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-card-container">
        <Box className="dashboard-box-card">
          <Grid container className="dashboard-card-grid">
            <Grid item xs={12} md={12}>
              <form className="ticket-form" onSubmit={handleSubmit(onSubmit)}>
                {/* Title */}
                <div className="form-group">
                  <label className="reportName"> Title <span style={{ color: "red" }}>*</span></label>
                  <input
                    type="text"
                    placeholder="Write your issues"
                    {...register('title', { required: 'Title is required' })}
                  />
                  {errors.title && <span style={{ color: "red" }}>{errors.title.message}</span>}
                </div>
                {/* Description */}
                <div className="form-group">
                  <label className="reportName">Issue Description <span style={{ color: "red" }}>*</span></label>
                  <textarea
                    placeholder="Write your description"
                    {...register('description', { required: 'Description is required' })}
                  />
                  {errors.description && <span style={{ color: "red" }}>{errors.description.message}</span>}
                </div>

                {/* File Upload */}
                <div className="form-group">
                  <label className="reportName">Upload Document(s)</label>
                  <input type="file" {...register('document')} />
                  <span style={{ fontsize: "12px" }}>Note:Attach any images/videos/files that may assist us to help you
                  </span>
                </div>

                {/* Buttons */}
                <div className="form-actions">
                  <button type="button" className="cancel" onClick={() => navigate('/')}>
                    Cancel
                  </button>
                  <button type="submit" className="submit">
                    Create Ticket
                  </button>
                </div>
              </form>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2025 |
                  <a href="https://www.egrovesys.com/" target="blank">
                    <span className="footer-brand">eGrove Systems</span>
                  </a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* <CommonBreadCrumb breadcrumbValue={[
        { title: 'Support Ticket', activeColor: true }
      ]} />
      <div className="cnt_hdr_top_wraps">
        <div className="cnt_hdr_top_lft_wrap">
          <h2 className="heading_font">Support Ticket</h2>

        </div>

        <Helmet>
          <meta charSet="utf-8" />
          <title> Support Ticket </title>
        </Helmet>
      </div>
      <form className="ticket-form" onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group">
          <label className="reportName"> Title <span style={{ color: "red" }}>*</span></label>
          <input
            type="text"
            placeholder="Write your issues"
            {...register('title', { required: 'Title is required' })}
          />
          {errors.title && <span style={{ color: "red" }}>{errors.title.message}</span>}
        </div>
        <div className="form-group">
          <label className="reportName">Issue Description <span style={{ color: "red" }}>*</span></label>
          <textarea
            placeholder="Write your description"
            {...register('description', { required: 'Description is required' })}
          />
          {errors.description && <span style={{ color: "red" }}>{errors.description.message}</span>}
        </div>

        <div className="form-group">
          <label className="reportName">Upload Document(s)</label>
          <input type="file" {...register('document')} />
          <span style={{ fontsize: "12px" }}>Note:Attach any images/videos/files that may assist us to help you
          </span>
        </div>

        <div className="form-actions">
          <button type="button" className="cancel" onClick={() => navigate('/')}>
            Cancel
          </button>
          <button type="submit" className="submit">
            Create Ticket
          </button>
        </div>
      </form> */}
    </div>
  );
};

export default CreateTicketForm;
